<script>
import EntitiesTable from '$common/EntitiesTable'
import courses from '@/global/js/courses'
export default {
  name: 'AdminCourses',
  components: {
    'entities-table': EntitiesTable,
  },
  data() {
    return {
      courses,
      classes: {},
      students: [],
      sorting: {
        by: 'Name',
        ascending: true,
      },
      cells: [
        {
          name: 'Name',
          getInfo: aClass => aClass.name,
          sortFunc: (a, b) => a.name.localeCompare(b.name),
        },
        {
          name: 'Students',
          getInfo: aClass =>
            this.students.filter(student => student.classes.includes(aClass.id))
              .length,
          sortFunc: (a, b) => {
            const countStudents = aClass =>
              this.students.filter(student =>
                student.classes.includes(aClass.id)
              ).length
            return countStudents(b) - countStudents(a)
          },
        },
        {
          name: 'Edit Info',
          getInfo: () => 'Edit',
          classFunc: () => 'action-link',
          onClick: aClass => {
            if (!this.classes[aClass.id].date_start)
              return this.$toast({ copy: 'Legacy classes cannot be edited.' })
            this.$modals.show({
              name: 'create-class',
              onSuccess: this.getEntities,
              info: this.classes[aClass.id],
              hardClose: true,
            })
          },
        },
      ],
      currentTab: 'Current/Upcoming',
      tabs: [
        {
          title: 'Current/Upcoming',
        },
        {
          title: 'Finished',
        },
      ],
    }
  },
  computed: {
    classArr() {
      const arr = []
      Object.keys(this.classes).forEach(classId => {
        const aClass = this.classes[classId]
        const course = courses[aClass.course_id]
        arr.push({
          name: `${course.name} - ${aClass.month}`,
          id: classId,
          month: aClass.month,
        })
      })
      return arr
    },
    sortedClasses() {
      const sortFunc = this.cells.find(cell => cell.name === this.sorting.by)
        .sortFunc
      const sorted = this.$clone(this.classArr)
        .filter(aClass => {
          if (this.currentTab === 'Current/Upcoming')
            return !this.classes[aClass.id].done
          else if (this.currentTab === 'Finished')
            return this.classes[aClass.id].done
          else return true
        })
        .sort(sortFunc)
      return this.sorting.ascending ? sorted : sorted.reverse()
    },
  },
  methods: {
    async getEntities() {
      this.students = (await this.$firestore
        .collection('users')
        .where('user_type', 'array-contains', 'ONLINE_STUDENT')
        .get()).docs.map(doc => doc.data())
      this.classes = await this.$classes().classList()
    },
  },
  async mounted() {
    this.getEntities()
    this.$firestore.collection('classes').onSnapshot(async qs => {
      this.classes = await this.$classes().classList()
    })
  },
}
</script>

<template lang="pug">
  #admin-courses-main.admin-main
    .admin-courses-container.admin-container
      .admin-title Courses
        .button.pro-button.minor(@click='$modals.show({name: "create-class", onSuccess: getEntities,})') Create Class
      .admin-content
        .tab-holder
            .tab(
              v-for='tab in tabs'
              :class='currentTab === tab.title ? "active" : "inactive"'
              @click='currentTab = tab.title'
            ) {{tab.title}}
        entities-table(
          :entities='sortedClasses'
          :cells='cells'
          :initialSorting='sorting'
          customColumnWidths='450px 120px 180px 140px auto'
          @onSortingChange='newSorting => sorting = newSorting'
        )
</template>

<style lang="sass" scoped>
@import '$styles/admin.sass'
#admin-courses-main
  .admin-courses-container
</style>
